import DataEntity from "@/server/com/silkplm/engine/db/model/DataEntity";
import {
    checkIfEnabledByOrganizationFormsSettingsForForm
} from "@/components/forms/customizations/plm/EntityEditFormService";
import Rpc from "@/Rpc";
import StreamingQuery from "@/components/forms/StreamingQuery";
import StreamingEngine from "@/components/forms/StreamingEngine";
import CacheManager from "@/components/cacheManager/CacheManager";
import Currency from "@/server/com/silkplm/model/plm/dictionaries/Currency";

export async function checkIfThereAreDynamicFieldsOnTheGrid(form) {
    let dataEntity = new DataEntity();
    let classDataEntity = dataEntity.getRemoteClass();
    let enabledFromConfiguration = false;
    if (form?.formId) {
        enabledFromConfiguration = checkIfEnabledByOrganizationFormsSettingsForForm(form.formId);
        if (!enabledFromConfiguration) {
            return false;
        }
    }
    if ((form && (form.dynamicCells !== classDataEntity && form.dynamicCells !== null)) &&
        (form && (form.dynamicColumns !== classDataEntity && form.dynamicColumns !== null))) {
        let count = await CacheManager.getDynamicColumnsNumber(form.dynamicColumns);
        return !!count;

    } else {
        return false;
    }
}

export async function getFilteredRecordsFromDatabaseWithRows(formConfig, detailsMasterId) {
    let enabledByConfiguration = checkIfEnabledByOrganizationFormsSettingsForForm(formConfig.formId);
    if (!enabledByConfiguration) {
        return [null, null];
    }
    let hasListPermission = SessionManager.hasPermission(formConfig.effectivePermissionList);
    if (!hasListPermission) {
        return [null, null];
    }
    let fullClass = formConfig.formClassLong;
    let dynamicRowsFormConfig = FormsLoader.detectFormConfig(fullClass)
    let filter = [{
        "fieldName": dynamicRowsFormConfig.fieldForFilterForDynamicColumns,
        "filterSpec": {
            "idValues": [
                detailsMasterId
            ]
        }
    }];
    let params = [fullClass, filter];
    let listOfDynamicColumnsEntities = await Rpc.Forms.listExtendedEntitiesWithColFilters(...params).lock();
    let dynamicRows = [];
    dynamicRows = [...listOfDynamicColumnsEntities];
    return [dynamicRows, dynamicRowsFormConfig]
}

export async function getAllRecordsFromDatabaseWithRows(fullClass) {
    let dynamicRowsFormConfig = FormsLoader.detectFormConfig(fullClass)
    let listOfDynamicColumnsEntities = await Rpc.Forms.listExtendedEntities(fullClass).lock();
    let dynamicRows = [];
    dynamicRows = [...listOfDynamicColumnsEntities];
    return [dynamicRows, dynamicRowsFormConfig]
}

export async function getRecordsFromDatabaseWithRowsWhenStreaming(form, fullClass, onlyIds, excludedIds) {
    let dynamicRowsFormConfig = FormsLoader.detectFormConfig(fullClass)

    let funNameOrStreamingQuery = new StreamingQuery();

    funNameOrStreamingQuery.case = "LIST EXTENDED ENTITIES";
    funNameOrStreamingQuery.dataClass = fullClass;
    funNameOrStreamingQuery.form = form;
    funNameOrStreamingQuery.onlyIds = onlyIds;
    funNameOrStreamingQuery.excludedIds = excludedIds;
    funNameOrStreamingQuery.colFilterSpec = [];

    let enabledFromConfiguration = checkIfEnabledByOrganizationFormsSettingsForForm(form.formId);
    if (enabledFromConfiguration) {
        // domyslne sortowanie
        if (!funNameOrStreamingQuery.order.length) {
            let sort = null;

            for (let f of form.fields) {
                if (f.typeOfSortOfColumn) {
                    if (!sort || sort.fieldName == 'EID') {
                        sort = {
                            colName: f.fieldName,
                            ascend: f.typeOfSortOfColumn == 'asc' || f.typeOfSortOfColumn == 'ascend'
                        }
                    }
                }
            }   

            if (sort) {
                funNameOrStreamingQuery.order = [sort];
            }
        }

        let results = await Rpc.FormsStreams.startStream(funNameOrStreamingQuery.toFormStreamingQuery()).lock();

        return [results.records, dynamicRowsFormConfig]
    }
    return [[], dynamicRowsFormConfig]
}

export async function getAllRecordsFromDatabaseWithDynamicCells(fullClass, dynamicRows) {
    let dynamicCellFormConfig = FormsLoader.detectFormConfig(fullClass)
    let dynamicCells = [];

    let idValues = [];
    dynamicRows.forEach(row => {
        idValues.push(row.id);
    })

    if (idValues.length > 0) {
        let filter = [{
            "fieldName": dynamicCellFormConfig.fieldForFilterForDynamicColumns,
            "filterSpec": {
                "idValues": idValues
            }
        }];
        let params = [fullClass, filter];
        let listOfDynamicCellsEntities = await Rpc.Forms.listExtendedEntitiesWithColFilters(...params).lock();
        for (let dynamicCell of listOfDynamicCellsEntities) {
            dynamicCells.push(dynamicCell);
        }
    }
    return [dynamicCells, dynamicCellFormConfig]
}

export async function getAllRecordsFromDatabaseWithDynamicColumns(fullClass, dynamicCells, dynamicCellFormConfig) {
    let dynamicColsFormConfig = FormsLoader.detectFormConfig(fullClass)
    let listOfDynamicColumnsEntities = [];

    let setOfDynamicCells = [];
    dynamicCells.forEach(col => {
        setOfDynamicCells.push(col[dynamicCellFormConfig.columnFieldForDynamicColumns])
    })

    if(setOfDynamicCells.length > 0) {
        let filter = [{
            "fieldName": dynamicColsFormConfig.fieldForFilterForDynamicColumns,
            "filterSpec": {
                "idValues": setOfDynamicCells
            }
        }];
        let params = [fullClass, filter];
        let tempListOfDynamicColumnsEntities = await Rpc.Forms.listExtendedEntitiesWithColFilters(...params).lock();
        for (let tempDynamicColumn of tempListOfDynamicColumnsEntities) {
            if (!listOfDynamicColumnsEntities.some(element => isEqual(element, tempDynamicColumn))) {
                listOfDynamicColumnsEntities.push(tempDynamicColumn);
            }
        }
    }
    let dynamicColumns = [];

    let ids = []
    for (let entity of listOfDynamicColumnsEntities){
        ids.push(entity[dynamicColsFormConfig.columnFieldForDynamicColumns])
    }
    let columnsLabelsEntities = await Rpc.Forms.listExtendedEntitiesByListOfIds(dynamicColsFormConfig.classForDynamicColumnsLabel, ids)

    for (let index in listOfDynamicColumnsEntities) {
        let entity = listOfDynamicColumnsEntities[index];
        let columnLabelEntity = columnsLabelsEntities[index];
        let tempObject = {}
        tempObject["columnEntity"] = entity;
        tempObject["columnLabelEntity"] = columnLabelEntity;
        dynamicColumns.push(tempObject);
    }
    if (dynamicColsFormConfig.fieldOrderForDynamicColumns !== null) {
        dynamicColumns.sort((a, b) => customSortFunction(a, b, dynamicColsFormConfig));
    }

    let uniqueDataForColoringDynamicColumns = null;
    if (dynamicColsFormConfig.fieldByWhichColoringWillBeDistinguishedForDynamicColumns !== null) {
        uniqueDataForColoringDynamicColumns = new Set();
        for (let column of dynamicColumns) {
            uniqueDataForColoringDynamicColumns.add(column.columnEntity[dynamicColsFormConfig.fieldByWhichColoringWillBeDistinguishedForDynamicColumns]);
        }
    }
    return [dynamicColumns, dynamicColsFormConfig, uniqueDataForColoringDynamicColumns]

}

export function isEqual(obj1, obj2) {
    return obj1.id === obj2.id;
}

export function customSortFunction(a, b, dynamicColsFormConfig,) {
    let value1 = a.columnLabelEntity[dynamicColsFormConfig.fieldOrderForDynamicColumns];
    let value2 = b.columnLabelEntity[dynamicColsFormConfig.fieldOrderForDynamicColumns];
    let value3 = null;
    let value4 = null;
    if (dynamicColsFormConfig?.extraFieldOrderForDynamicColumns !== null) {
        value3 = a.columnLabelEntity[dynamicColsFormConfig.extraFieldOrderForDynamicColumns];
        value4 = b.columnLabelEntity[dynamicColsFormConfig.extraFieldOrderForDynamicColumns];
    }
    if (value1 !== value2) {
        return value1 - value2;
    }
    if (value3 !== null && value4 !== null) {
        return value3 - value4;
    }
    return value1 - value2;
}

